// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"799fc4fe","54":"d01b999a","126":"a6430e2f","145":"519a6b24","162":"001e957f","196":"72c28938","281":"537e1968","325":"17d01a09","410":"2fb50cb5","599":"430296d8","664":"d4d8ce65","726":"687a80ab","779":"e233196f","787":"2136aea4"}[chunkId] + ".chunk.js";
};